import React, { useState, useEffect } from "react";
import { Box, Modal } from "@mui/material";
import { Download } from "../../";

function DownloadModal({ setUuid, uuid }) {
	const [error, setError] = useState(null);

	useEffect(() => {
		if (error === false) {
			setTimeout(() => {
				setUuid(null);
				setError(null);
			}, 1000);
		}
	}, [error]);

	return (
		<Modal
			open={uuid !== null}
			// onClose={() => setUuid(null)}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: 400,
					bgcolor: "background.paper",
					border: "2px solid #000",
					boxShadow: 24,
					// p: 4,
				}}
			>
				<Download id={uuid} setError={setError} />
			</Box>
		</Modal>
	);
}

export default DownloadModal;
